import { render } from "./TrekInfo.vue?vue&type=template&id=d52949ae&scoped=true"
import script from "./TrekInfo.vue?vue&type=script&lang=js"
export * from "./TrekInfo.vue?vue&type=script&lang=js"

import "./TrekInfo.vue?vue&type=style&index=0&id=d52949ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52949ae"]])

export default __exports__